import { j as s } from "../../jsx-runtime-Wav_3Wde.js";
import r from "../BaseIcon.mjs";
const n = (o) => /* @__PURE__ */ s.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "Cross",
  ...o,
  children: /* @__PURE__ */ s.jsx("g", {
    children: /* @__PURE__ */ s.jsx("polygon", {
      points: "22,4.86 19.14,2 12,9.14 4.86,2 2,4.86 9.14,12 2,19.14 4.86,22 12,14.86 19.14,22 22,19.14 14.86,12"
    })
  })
}), i = (o) => /* @__PURE__ */ s.jsx(r, {
  IconSvg: n,
  ...o
});
export {
  i as default
};
